// extracted by mini-css-extract-plugin
module.exports = {"sort":"SP","selected":"TP","disabled":"UP"};